import { CurrentPartner } from 'components/currentPartner'
import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { TitleRow } from 'components/titleRow'
import { useOrganizations } from 'hooks/admin/useOrganizations'
import { useShowsAdmin } from 'hooks/admin/useShows'
import React from 'react'
import { useParams } from 'react-router-dom'

import { ShowListAdmin } from './list/showListAdmin'
import { Container, ContainerWrapper } from './shows.style'

export const ShowsAdmin = () => {
    const { partnerId } = useParams<{ partnerId?: string }>()
    const { showsData, showsLoading, showsError, linkToForm, tableConfig, handleDelete, handleEdit, handleSearch } =
        useShowsAdmin(partnerId)

    const { data } = useOrganizations()
    const partnerName = React.useMemo(() => data?.find((org) => org.org_id === partnerId)?.name, [data, partnerId])

    return (
        <Container>
            <ContainerWrapper>
                {partnerId && partnerName && <CurrentPartner partnerName={partnerName}></CurrentPartner>}
                <TitleRow
                    configData={tableConfig.titleRow}
                    onSearch={handleSearch}
                    linkTo={linkToForm}
                    linkLabel={tableConfig.titleRow.buttonLabel}
                />
                <LoadingContainer isLoading={showsLoading} error={showsError}>
                    {showsData && showsData.length > 0 ? (
                        <ShowListAdmin data={showsData} onEdit={handleEdit} onDelete={handleDelete} />
                    ) : (
                        <PlaceholderContainer>
                            <p>Jelenleg nincsenek előadások. Hozz létre újat!</p>
                        </PlaceholderContainer>
                    )}
                </LoadingContainer>
            </ContainerWrapper>
        </Container>
    )
}
